/**
 * Stable CSS class names for E2E — ScheduleCreate Header tab.
 */
export const SCH = {
    root: 'schedule-header-tab',
    rows: 'schedule-header-tab__rows',
    row: 'schedule-header-tab__row',
    keyInput: 'schedule-header-tab-input__key',
    valueInput: 'schedule-header-tab-input__value',
    removeButton: 'schedule-header-tab-input--button-remove',
    removeIcon: 'schedule-header-tab__remove-icon',
    addButton: 'schedule-header-tab-input--button-add',
    addIcon: 'schedule-header-tab__add-icon',
    addText: 'schedule-header-tab__add-text',
} as const;

export const schCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

